import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import PageNavigation from './PageNavigation';
import Title from '../../components/Title';
import {
    getClient,
    oneClient,
    getClientProducts,
    getClientTermsAndPrivacy,
    getClientPackages,
    getClientDataStore,
    getClientReleaseVersion,
} from '../../redux/slices/clientsSlice';
import { getPackages } from '../../redux/slices/insuranceSlice';

export default function ClientProfilePage() {
    const dispatch = useDispatch();
    const params = useParams();
    const client = useSelector(oneClient);

    const fetchClientProfileData = useCallback(async () => {
        const response = await dispatch(getClient(params.id)).unwrap();

        dispatch(getClientTermsAndPrivacy(params.id));
        dispatch(
            getClientProducts({
                client: response.client_uid,
                url: response.api_url,
            }),
        );
        dispatch(getPackages());
        dispatch(getClientPackages(response.client_uid));
        dispatch(
            getClientDataStore({
                id: response.client_uid,
                collectionName: 'clients',
            }),
        );
        dispatch(getClientReleaseVersion(response.api_url));
    }, [dispatch, params.id]);

    useEffect(() => {
        fetchClientProfileData();
    }, [fetchClientProfileData]);

    return (
        <div>
            <Title subText={client?.api_url}>{client?.name}</Title>
            <div className="navigation-tabs__wrapper">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
